<template>
  <div class="taoBao">
    <!-- 顶部大图片 -->
    <imgBigCards path="/layout/list/boutiqueTaobaoQuestions"></imgBigCards>
    <!-- 输入框 -->
    <div class="box-input">
      <inputBox
        @query="queryList"
        placeholder="请输入关键字（年级/学科/地区/类型/年份）"
        v-model:inputValue="mydata.form.search"
      ></inputBox>
    </div>
    <!-- 模块1 -->
    <div class="box-taobao1">
      <!-- 年级筛选按钮 -->
      <subjectButtonVmodel
        v-model:myValue="mydata.form.grade_id"
        :filterButton="mydata.filterButton1"
        @change="getData"
        :key="mydata.testKey0"
        style="margin-bottom: 10px"
      ></subjectButtonVmodel>
      <subjectButtonVmodel
        v-model:myValue="mydata.form.subject_id"
        :filterButton="mydata.filterButton2"
        @change="getData"
        :key="mydata.testKey1"
        style="margin-bottom: 10px"
      ></subjectButtonVmodel>
      <subjectButtonVmodel
        v-model:myValue="mydata.form.address_id"
        :filterButton="mydata.filterButton3"
        @change="getData"
        :key="mydata.testKey2"
        style="margin-bottom: 10px"
      ></subjectButtonVmodel>
      <subjectButtonVmodel
        v-model:myValue="mydata.form.type_id"
        :filterButton="mydata.filterButton4"
        @change="getData"
        :key="mydata.testKey3"
        style="margin-bottom: 10px"
      ></subjectButtonVmodel>
      <subjectButtonVmodel
        v-model:myValue="mydata.form.year_id"
        :filterButton="mydata.filterButton5"
        @change="getData"
        :key="mydata.testKey4"
        style="margin-bottom: 10px"
      ></subjectButtonVmodel>

      <div class="search-bottom-box">
        <el-checkbox-button
          v-model="mydata.form.is_new"
          :true-value="1"
          :false-value="0"
          @change="checkboxChange('is_new')"
        >
          最新上传
        </el-checkbox-button>
        <el-checkbox-button
          v-model="mydata.form.is_recommended"
          :true-value="1"
          :false-value="0"
          @change="checkboxChange('is_recommended')"
        >
          下载最多
        </el-checkbox-button>
      </div>
    </div>
    <!--模块2  -->
    <div class="box-taobao2">
      <bookBigListenCards
        v-for="(item, index) in mydata.examSearchArr"
        :key="index"
        :info="item"
        path="/layout/list/topicSubjectDetails"
        @getListReload="getData"
      ></bookBigListenCards>
      <!-- 空白内容组件 -->
      <glEmpty v-if="mydata.examSearchArr.length === 0"></glEmpty>
    </div>
    <!--分页 -->
    <div class="gl-pagination">
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
// 是否来自其他模块
let fromOtherModule = false;
// 是否来自综合模块
let fromCompositeModule = false;
// 缓存组件
import { defineComponent } from "vue";
export default defineComponent({
  name: "listenBig",
  beforeRouteEnter(to, from, next) {
    // 如果是来自综合模块，那么把fromCompositeModule设置成true值
    if (from.path === "/layout/list/boutiqueTaobaoQuestions") {
      fromCompositeModule = true;
    }
    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
    if (
      [
        "/layout/list/boutiqueTaobaoQuestions",
        "/layout/list/topicSubjectDetails",
      ].includes(from.path) === false
    ) {
      fromOtherModule = true;
      // console.log('来自其他模块');
    }
    next();
  },
});
</script>



<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";
import subjectButtonVmodel from "@/components/subjectButtonVmodel/index.vue";
import bookBigListenCards from "@/components/bookBigListenCards/index.vue";

//获取淘题搜索列表接口
import { examSearchList } from "@/api/boutiqueTaobaoQuestions/listenBig/index.js";

import { useRouter, useRoute } from "vue-router";

import { reactive, onActivated } from "vue";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  currentPage3: "5",
  pageSize3: "100",
  small: false,
  background: false,
  disabled: false,

  //筛选按钮
  filterButton1: {
    title: "年级",
    filter: JSON.parse(localStorage.getItem("grade_list")) ?? [],
  },
  filterButton2: {
    title: "学科",
    filter: JSON.parse(localStorage.getItem("subject_list")) ?? [],
  },
  filterButton3: {
    title: "地区",
    filter: JSON.parse(localStorage.getItem("address_list")) ?? [],
  },
  filterButton4: {
    title: "类型",
    filter: JSON.parse(localStorage.getItem("type_list")) ?? [],
  },
  filterButton5: {
    title: "年份",
    filter: JSON.parse(localStorage.getItem("year_list2")) ?? [],
  },
  testKey0: new Date().getTime() - Math.random() * 10,
  testKey1: new Date().getTime() - Math.random() * 100,
  testKey2: new Date().getTime() - Math.random() * 1000,
  testKey3: new Date().getTime() - Math.random() * 10000,
  testKey4: new Date().getTime() - Math.random(),

  form: {
    // column_id: getUrlId(route.path), // 栏目id值
    search: "", // 搜索查询

    grade_id: "", // 年级
    subject_id: "", //学科
    address_id: "", //地区
    type_id: "", //类型
    year_id: "", // 年份
    is_new: "", //是否最新（不传或者传0：否，1：是）
    is_recommended: "", //是否推荐（不传或者传0：否，1：是）
  },

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 8, // 每页条数
    total: 0, // 总的条数
  },

  examSearchArr: [], //淘题搜索列表
});
// console.log(route.query);

onActivated(() => {
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
  // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
    //筛选按钮
    mydata.filterButton1 = {
      title: "年级",
      filter: JSON.parse(localStorage.getItem("grade_list")) ?? [],
    };
    mydata.filterButton2 = {
      title: "学科",
      filter: JSON.parse(localStorage.getItem("subject_list")) ?? [],
    };
    mydata.filterButton3 = {
      title: "地区",
      filter: JSON.parse(localStorage.getItem("address_list")) ?? [],
    };
    mydata.filterButton4 = {
      title: "类型",
      filter: JSON.parse(localStorage.getItem("type_list")) ?? [],
    };
    mydata.filterButton5 = {
      title: "年份",
      filter: JSON.parse(localStorage.getItem("year_list2")) ?? [],
    };
    mydata.testKey0 = new Date().getTime() - Math.random() * 10;
    mydata.testKey1 = new Date().getTime() - Math.random() * 100;
    mydata.testKey2 = new Date().getTime() - Math.random() * 1000;
    mydata.testKey3 = new Date().getTime() - Math.random() * 10000;
    mydata.testKey4 = new Date().getTime() - Math.random();
    mydata.form = {
      // column_id: getUrlId(route.path), // 栏目id值
      search: "", // 搜索查询

      grade_id: "", // 年级
      subject_id: "", //学科
      address_id: "", //地区
      type_id: "", //类型
      year_id: "", // 年份
      is_new: "", //是否最新（不传或者传0：否，1：是）
      is_recommended: "", //是否推荐（不传或者传0：否，1：是）
    };
    mydata.pageObj = {
      currentPage: 1, // 当前页数
      pageSize: 8, // 每页条数
      total: 0, // 总的条数
    };
    mydata.examSearchArr = []; //淘题搜索列表

    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getData();
  }

  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false;

  if (localStorage.getItem("v") !== null) {
    // 分页变成第一页
    mydata.pageObj.currentPage = 1;
    mydata.form.search = localStorage.getItem("v"); // 获取本地存储并且赋值
    localStorage.removeItem("v"); // 赋值后立刻删除本地存储内容

    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getData();
    // getData()
    // 拿到query参数并且赋值之后，就进行二次跳转，把query参数删除了，避免详情页面后退到列表页面的时候，再次拿到query参数并且赋值
    // router.push({
    //   path:"/layout/list/addedServices"
    // })
  }

  // 如果是从综合页面跳转进来的，那么就获取path参数，并且查询列表
  if (fromCompositeModule) {
    mydata.pageObj.currentPage = 1;
    /////////////////////////////////////////////////////
    mydata.form.search =
      route.query.search === undefined || route.query.search === ""
        ? mydata.form.search
        : route.query.search;
    mydata.form.grade_id =
      route.query.grade_id === undefined || route.query.grade_id === ""
        ? mydata.form.grade_id
        : Number(route.query.grade_id);
    mydata.form.subject_id =
      route.query.subject_id === undefined || route.query.subject_id === ""
        ? mydata.form.subject_id
        : Number(route.query.subject_id);
    mydata.form.address_id =
      route.query.address_id === undefined || route.query.address_id === ""
        ? mydata.form.address_id
        : Number(route.query.address_id);
    mydata.form.type_id =
      route.query.type_id === undefined || route.query.type_id === ""
        ? mydata.form.type_id
        : Number(route.query.type_id);
    mydata.form.year_id =
      route.query.year_id === undefined || route.query.year_id === ""
        ? mydata.form.year_id
        : route.query.year_id;
    mydata.form.is_new =
      route.query.is_new === undefined || route.query.is_new === ""
        ? mydata.form.is_new
        : Number(route.query.is_new);
    mydata.form.is_recommended =
      route.query.is_recommended === undefined ||
      route.query.is_recommended === ""
        ? mydata.form.is_recommended
        : Number(route.query.is_recommended);
    /////////////////////////////////////////////////////
    getData();
  }
});

function topicButton() {
  router.push({
    path: "/layout/list/topicSubjectDetails",
  });
}
//////////////////////////////
// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  getData();
}

//////////////////////////////
// 查询列表
function queryList(dict, inputValue) {
  // 分页变成第一页
  mydata.pageObj.currentPage = 1;
  // 赋值
  mydata.form.search = inputValue;

  // 获取页面数据
  getData();

  // 查询
  // articleListFn();
}
//////////////////////////////

// 获取页面数据
function getData() {
  // 调用接口
  examSearchList({
    ...mydata.form,
    page: mydata.pageObj.currentPage,
    psize: mydata.pageObj.pageSize,
  }).then((res) => {
    // console.log(res.data.list, "高级搜索");
    mydata.examSearchArr = res.data.list;
    mydata.pageObj.total = res.data.count;
  });
}

// getData();

function checkboxChange(v) {
  // console.log(v);
  if (v === "is_recommended") {
    // console.log(mydata.form.is_recommended);
    if (mydata.form.is_recommended === 1) {
      mydata.form.is_new = "";
    }
  } else {
    //  console.log(mydata.form.is_new);
    if (mydata.form.is_new === 1) {
      mydata.form.is_recommended = "";
    }
  }

  getData();
}
</script>

<style scoped lang="scss">
.taoBao {
  background-color: #f9f9f9;
  // padding-bottom: 40px;
  
  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

  ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
    }
    //////按钮消失一个
    :deep(.el-button.el-button--primary.box2) {
      display: none;
    }
  }

  //////模块1------搜索组件 和 按钮组件
  .box-taobao1 {
    background-color: #ffffff;
    margin: 0 auto;
    margin-top: 16px;
    margin-bottom: 16px;
    padding: 16px 0px;

   
  }
  ///////模块2------听力大卡片组件的大盒子
  .box-taobao2 {
    width: 343px;
    // height: 1352px;
    margin: 0 auto;
    // border: 1px solid blue;
    // padding: 30px;
    // border-radius: 8px;
    :deep(.book-listen) {
      margin-bottom: 16px;
    }
  }
  //////分页
  .paging {
    // margin: 0 auto;
    margin-top: 20px;
    // margin-bottom: 40px;
    display: flex;
    justify-content: center;
    // border:1px solid red;

    :deep(.el-button.is-plain) {
      margin-left: 24px;
    }
  }

  .demo-pagination-block + .demo-pagination-block {
    margin-top: 10px;
  }
  .demo-pagination-block .demonstration {
    margin-bottom: 16px;
  }
}
.search-bottom-box {
  margin-top: 20px;
  margin-left: 60px;
  :deep(.el-checkbox-button) {
    margin-right: 20px;
    span {
      border: 1px solid #dcdfe6;
      border-radius: 5px;
    }
  }
  :deep(.el-checkbox-button.is-checked) {
    span {
      background-color: #009de0;
      border-color: #009de0;
    }
  }
}
</style>
